module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 3.2C32 1.43 30.57 0 28.8 0H3.2C1.43 0 0 1.43 0 3.2v25.6C0 30.57 1.43 32 3.2 32h25.6c1.77 0 3.2-1.43 3.2-3.2V3.2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/stop-2.js
// module id = 1434
// module chunks = 14